module.exports = __webpack_public_path__ + "img/delivery-schedule.fc5eaecc.svg";